module.exports = "<p>\n  b2b-reports works!\n</p>\n"